function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useEffect, useMemo } from "react";
import logger, { LapelError } from "../../../logger";
import config from "../../../config";
import AsyncCache, { STATUS_REJECTED, STATUS_RESOLVED } from "../../../utils/AsyncCache";
import { useURL } from "../../../hooks";
import { subscribe as sub } from "../../../utils/pubsub";
import { broadcastToDocument } from "../../../utils";
import { getRemotePageParameters } from "../../../hocs/federated-target-page-parameters";
import analytics, { EventNames } from "../../../analytics";
import { delivery, adobeValues } from "../../../utils/lpe-cache/apis/delivery";
export var mboxCache = new AsyncCache({
    id: "mbox",
    chunkSize: 50,
    getKey: function(param) {
        var name = param.name;
        return name;
    },
    onAdd: function(item, key, param) {
        var cache = param.cache;
        var _global, _adobe_response, _adobe;
        // REQUIRED FOR TESTS TO PASS
        // TODO:  we should find another way to handle this, maybe the manifest
        var name = item.name, parameters = item.parameters, profileParameters = item.profileParameters, url = item.url, isGlobal = item.isGlobal;
        // Check for locally cached data
        var adobe = (((_global = global) == null ? void 0 : _global.TARGET_STATE) || {}).adobe;
        var _ref = ((_adobe = adobe) == null ? void 0 : (_adobe_response = _adobe.response) == null ? void 0 : _adobe_response.execute) || {}, _ref_mboxes = _ref.mboxes, mboxes = _ref_mboxes === void 0 ? [] : _ref_mboxes;
        var matchedMbox = mboxes.find(function(resMbox) {
            return cache.getKey(resMbox) === key;
        });
        if (matchedMbox) {
            return _extends({
                name: name,
                parameters: parameters,
                profileParameters: profileParameters,
                url: url,
                isGlobal: isGlobal
            }, matchedMbox, {
                status: STATUS_RESOLVED,
                resolvedAt: Date.now()
            });
        }
        return {
            name: name,
            parameters: parameters,
            profileParameters: profileParameters,
            url: url,
            isGlobal: isGlobal
        };
    },
    /*
    Fetch data from remote sources for mbox objects without fresh data
    Report new data to Adobe Analytics (global._satellite)
    Return fetched data to update local cache
  */ onExecute: /*#__PURE__*/ _async_to_generator(function(pending, param) {
        var cache, _window, _results_execute, _results, globalParameters, _tmp, pageParameters, results, mboxResults;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    cache = param.cache;
                    if (!((_window = window) == null ? void 0 : _window.targetPageParams)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        window.targetPageParams()
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = {};
                    _state.label = 3;
                case 3:
                    globalParameters = _tmp;
                    return [
                        4,
                        getRemotePageParameters().catch(function(err) {
                            logger.error(err);
                            return {};
                        })
                    ];
                case 4:
                    pageParameters = _state.sent();
                    // do not await tracking
                    analytics.track(EventNames.TESTS_REQUEST_SENT, {
                        pending: pending,
                        globalParameters: globalParameters,
                        pageParameters: pageParameters
                    });
                    // Remove at_property because adobe
                    delete globalParameters.at_property;
                    return [
                        4,
                        delivery({
                            execute: {
                                mboxes: pending.map(function(param, index) {
                                    var name = param.name, parameters = param.parameters, profileParameters = param.profileParameters;
                                    return {
                                        name: name,
                                        parameters: _extends({
                                            mbox3rdPartyId: adobeValues.thirdPartyId
                                        }, globalParameters, pageParameters, parameters),
                                        profileParameters: profileParameters,
                                        index: index
                                    };
                                })
                            }
                        })
                    ];
                case 5:
                    results = _state.sent();
                    mboxResults = ((_results = results) == null ? void 0 : (_results_execute = _results.execute) == null ? void 0 : _results_execute.mboxes) || [];
                    // do not await tracking
                    analytics.track(EventNames.TESTS_REQUEST_RECEIVED, mboxResults);
                    return [
                        2,
                        mboxResults
                    ];
            }
        });
    }),
    debounceTime: function() {
        return config().mboxes.fetchDebounceTime;
    }
});
sub("mbox-cache@execute-begin", function() {
    broadcastToDocument("LAPEL_BATCH_REQUEST_BEGIN");
});
sub("mbox-cache@execute-errored", function(error, errors) {
    logger.debug(error, errors);
    broadcastToDocument("LAPEL_BATCH_REQUEST_ERRORED");
});
sub("mbox-cache@execute-completed", function(success) {
    if (success) {
        broadcastToDocument("LAPEL_BATCH_REQUEST_SUCCESS");
    }
    broadcastToDocument("LAPEL_BATCH_REQUEST_COMPLETE");
});
sub("beforePageView", function() {
    /* a route change has started */ mboxCache.lock("pageView");
});
sub("pageView", function() {
    /* a route change has completed */ mboxCache.clear();
    mboxCache.unlock("pageView");
});
sub("pageLoadBegin", function() {
    /* page data is being fetched */ mboxCache.lock("pageLoad");
});
sub("pageLoadComplete", function() {
    /* page data has been fetched */ mboxCache.unlock("pageLoad");
});
var useMboxView = function(name) {
    var _useState = _sliced_to_array(useState(null), 2), cachedMbox = _useState[0], setCachedMbox = _useState[1];
    useEffect(function() {
        setCachedMbox(mboxCache.get({
            name: name
        }));
        var key = mboxCache.getKey({
            name: name
        }, {
            cache: mboxCache
        });
        var un = sub(mboxCache.id + "-cache-" + key + "-update", function(cachedItem) {
            setCachedMbox(cachedItem);
        });
        return function() {
            if (un && typeof un === "function") {
                un();
            }
        };
    }, [
        name
    ]);
    return cachedMbox;
};
var useMboxCache = function(param) {
    var name = param.name, parameters = param.parameters, profileParameters = param.profileParameters, onMboxError = param.onMboxError;
    var url = useURL();
    var _useState = _sliced_to_array(useState(mboxCache.add({
        name: name,
        parameters: parameters,
        profileParameters: profileParameters,
        url: url
    })), 2), cachedMbox = _useState[0], setCachedMbox = _useState[1];
    var firstMountTime = useMemo(function() {
        return Date.now();
    }, []);
    // eslint-disable-next-line sonarjs/cognitive-complexity
    useEffect(function() {
        var _config_lpeCache, _config;
        var un;
        var timeout = ((_config = config()) == null ? void 0 : (_config_lpeCache = _config.lpeCache) == null ? void 0 : _config_lpeCache.defaultTimeoutMS) || 3000;
        var timer = setTimeout(function() {
            setCachedMbox(function(previous) {
                if (AsyncCache.isDone(previous) === false) {
                    analytics.track(EventNames.FOOCMASK_TIMEDOUT);
                    var errMsg = new LapelError("Observation of mbox timeout");
                    if (typeof onMboxError === "function") {
                        onMboxError(errMsg);
                    }
                    return _extends({}, previous, {
                        status: STATUS_REJECTED,
                        errorMessage: errMsg
                    });
                }
                return previous;
            });
        }, timeout);
        try {
            un = mboxCache.subscribe({
                name: name,
                parameters: parameters,
                profileParameters: profileParameters,
                url: url
            }, function(mboxResult) {
                if (mboxResult === null) {
                    mboxCache.add({
                        name: name,
                        parameters: parameters,
                        profileParameters: profileParameters,
                        url: url
                    });
                    mboxCache.execute();
                } else {
                    if (AsyncCache.isDone(mboxResult) === true) {
                        analytics.track(EventNames.FOOCMASK_DEACTIVATED, Date.now() - firstMountTime);
                    }
                    setCachedMbox(_extends({}, mboxResult));
                }
            });
            mboxCache.execute();
        } catch (err) {
            if (typeof onMboxError === "function") {
                onMboxError(err);
            }
            logger.error(new LapelError(err.message + " while subscribing to mbox " + name, {
                cause: err
            }), {
                tags: {
                    functionName: "useMboxCache"
                },
                fingerprint: [
                    "useMboxCache",
                    name
                ]
            }, function(scope) {
                scope.setTag("ab-test", name);
            });
            setCachedMbox(_extends({}, cachedMbox, {
                status: STATUS_REJECTED,
                errorMessage: err
            }));
        }
        return function() {
            if (un && typeof un === "function") {
                un();
            }
            clearTimeout(timer);
        };
    }, [
        name,
        parameters,
        profileParameters,
        url,
        onMboxError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Adding cachedMbox to the dependencies causes an infinite loop when the request is cancelled
    return {
        cachedMbox: cachedMbox
    };
};
// isDone is a static method so it comes off the class
export var isDone = AsyncCache.isDone;
export { useMboxCache, useMboxView };

//# sourceMappingURL=mboxes.js.map